import idx from 'idx'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withHandlers, lifecycle } from 'recompose'
import withMixpanel, { SCREEN_VIEW_PROFILE } from 'utils/mixpanel'

import * as groupModule from 'modules/group'
import * as toastModule from 'modules/toast'
import * as peopleModule from 'modules/people'
import * as popoverModule from 'modules/popover'
import * as userActions from 'actions/userActions'
import * as routeActions from 'actions/routeActions'

export default compose(
  withMixpanel,
  connect(
    (state) => {
      const user = idx(state, _ => _.people.selected)
      const groups = idx(state, _ => _.groups.items)

      return {
        user,
        groups,
        organisation: idx(state, _ => _.organisation.selected),
        hasError: idx(state, _ => _.progress.login.hasError) || false,
        errorMessage: idx(state, _ => _.progress.login.error.message),
        isYou: user ? idx(state, _ => _.user.id) === user.id : false,
      }
    },
    (dispatch) => {
      const actions = {
        ...userActions,
        ...groupModule,
        ...toastModule,
        ...routeActions,
        ...peopleModule,
        ...popoverModule,
      }

      return {
        actions: bindActionCreators(actions, dispatch),
      }
    },
  ),
  withHandlers({
    onUserDeleteClick: ({
      actions, user, organisation, isYou
    }) => () => {
      if (isYou) {
        actions.showPopover(popoverModule.DELETE_ADMIN_BLOCKED, {
          hideCloseButton: true,
          title: 'Oops,',
          message: "Looks like you've tried to delete your own account.You can only do this on the Settings page.",
          onConfirm: () => {
            actions.hidePopover()
          }
        })
      } else {
        actions.showPopover(popoverModule.DELETE_PEOPLE_CONFIRM, {
          peopleCount: 1,
          hideCloseButton: true,
          organisationName: organisation.name,
          onConfirm: () => {
            actions.deletePeople(organisation, [user.userUuid], () => {
              actions.hidePopover()
              actions.redirect('/dashboard/people/all')
            })
          },
          onClose: () => {
            actions.hidePopover()
          }
        })
      }
    },
    onGroupAssignClick: ({ actions, user, organisation }) => () => {
      actions.showPopover(popoverModule.PEOPLE_ASSIGN_GROUPS, {
        filterAssignedGroups: true,
        onConfirm: (groups) => {
          actions.assignPeopleToGroups(organisation, [user.id], groups, () => {
            actions.hidePopover()
            actions.showToast(toastModule.SUCCESS_TOAST, `${user.fullName} has successfully been assigned`)
            actions.getUserGroups(user, organisation)
          })
        }
      })
    }
  }),
  lifecycle({
    componentDidMount() {
      this.props.track(SCREEN_VIEW_PROFILE)
    }
  })
)



// WEBPACK FOOTER //
// ./src/containers/people/PeopleDetails/PeopleDetails.enhancer.js